import { EuiButton, EuiButtonIcon, EuiFlexGroup } from "@inscopix/ideas-eui";
import { CellValueRendererFile } from "pages/gdt/cell-value-renderers/CellValueRendererFile";
import { Dispatch, Fragment, SetStateAction } from "react";

interface CellEditorFileHeaderProps {
  selectedFiles: {
    id: string;
    referenceId: string;
  }[];
  setSelectedFiles: Dispatch<
    SetStateAction<
      {
        id: string;
        referenceId: string;
      }[]
    >
  >;
  onClose: () => void;
}

export const CellEditorFileHeader = ({
  selectedFiles,
  setSelectedFiles,
  onClose,
}: CellEditorFileHeaderProps) => {
  /**
   * Deselects a file if previously selected.
   * @param fileId
   */
  const deselectFile = (fileId: string) => {
    setSelectedFiles((file) => file.filter(({ id }) => id !== fileId));
  };

  return (
    <EuiFlexGroup alignItems="center" gutterSize="s">
      <b>Selected:</b>

      {selectedFiles.map((file) => (
        <Fragment key={file.id}>
          <CellValueRendererFile fileId={file.id} suppressContextMenu />
          <EuiButtonIcon
            aria-label="Deselect file"
            iconType="cross"
            onClick={() => deselectFile(file.id)}
          />
        </Fragment>
      ))}

      <EuiButton
        size="s"
        color="text"
        style={{ marginLeft: "auto" }}
        onClick={onClose}
      >
        Close
      </EuiButton>
    </EuiFlexGroup>
  );
};
